import ZoneModal from './ZoneModal';

export default ZoneModal;
